/**
 * Verbatim owner-supplied copy for the /features page.
 * Do NOT rewrite, summarise, or punctuation-tweak.
 *
 * Linter note: this file is added to SKIP_FILES in scripts/check_ai_tells.py
 * because two of these strings ("...laws, and tells..." and
 * "...tamper-evident, and ready...") contain ", and " phrasing that is
 * part of the owner's exact wording.
 */

export const COMPASS_BODY =
  "Compass reads your situation, checks your lease against your state's tenancy laws, and tells you exactly where you stand. The acts, the codes, the awards, in plain English.";

export const PROVE_HERO_CALLOUT = {
  heading: "Tribunal-ready, the moment you need it.",
  body: "Export your whole case as one bundle: every document in date order, date-stamped, tamper-evident, and ready to hand over. You walk in organised, not scrambling.",
};
